import { useEffect } from "react";
import { Box } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "tss-react/mui";
import { Theme } from "@mui/material";

import WeekdayPicker, { WEEKDAYS } from "../../components/Inputs/WeekdayPicker";
import { EditFormDetails } from "../interfaces";

const useStyles = makeStyles()((theme: Theme) => ({
  greyText: {
    color: theme.vars.palette.text.secondary,
    fontSize: "small",
    fontWeight: "bold",
  },
}));

/** "1,0,1,1,1,0,1" is how the API stores a week. */
const EVERY_DAY = WEEKDAYS.map(() => "1").join(",");

const toDays = (value: string): number[] =>
  value.split(",").flatMap((enabled, day) => (enabled === "1" ? [day] : []));

const toStored = (days: number[]): string =>
  WEEKDAYS.map((day) => (days.includes(day) ? "1" : "0")).join(",");

/**
 * Which days the autopilot runs on.
 *
 * The same chips the group studio uses, with the stored "1,0,1" string
 * adapted here. `onEmpty="ignore"` keeps the old rule: unselecting the last
 * day does nothing, rather than quietly scheduling every day.
 */
export const WeekDaysRounded = ({
  filter,
  onChange,
  value,
}: {
  filter: EditFormDetails;
  name?: string;
  onChange: (value: string) => void;
  value: string;
}) => {
  const { classes } = useStyles();

  useEffect(() => {
    if (!value) {
      onChange(EVERY_DAY);
    }
  }, [value, onChange]);

  return (
    <>
      <span className={classes.greyText}>
        <FormattedMessage id={filter.label} />
      </span>
      <Box sx={{ mt: 0.5 }}>
        <WeekdayPicker
          value={toDays(value || EVERY_DAY)}
          onEmpty="ignore"
          onChange={(days) => onChange(toStored(days))}
        />
      </Box>
    </>
  );
};
